<template>
  <Card :card_class="'h-fit ' + container_class">
    <h1 class="font-bold text-white text-[2rem] tracking-wider">{{ title }}</h1>
    <p class="text-xl">{{ subtitle }}</p>
  </Card>
</template>

<script>
import Card from "@/components/organisms/Card.vue";

export default {
  props: {
    title: {
      type: String,
      default: "Untitled",
    },
    subtitle: {
      type: String,
      default: "Subtitle",
    },
    container_class: String,
  },
  components: {
    Card,
  },
};
</script>
